import { Routes, Route } from "react-router-dom";
import React, { useEffect, lazy } from "react";
import '@syncfusion/ej2-base/styles/material.css';       // Base styles including icons
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-react-schedule/styles/material.css';
import { loadScript } from "../Helpers/utils/loadScript";

const InstructorSchedule = lazy(() => import("../Pages/InstituteDashboard/Teacher Dashboard/TeacherSchedule/InstSchedule"));
const InstructorLearners = lazy(() => import("../Pages/InstructorLearners/InstructorLearners"));
const InstructorSettings = lazy(() => import("../Pages/InstructorSettings/InstructorSettings"));
const UserLeaveHistory = lazy(() => import("../Pages/UserLeaveHistory/UserLeaveHistory"));
const InstructorLessonsDisplay = lazy(() => import("../Pages/InstructorLessonsDisplay/InstructorLessonsDisplay"));
const InVehicleClass = lazy(() => import("../Pages/InVehicleClass"));
const InstructorSideLearnerDetails = lazy(() => import("../Pages/InstructorSideLearnerDetails/InstructorSideLearnerDetails"));
const InClassBatchDetails = lazy(() => import("../Pages/InClassBatchDetails/InClassBatchDetails"));
const InstructorWeeklySchedule = lazy(() =>import("../Pages/InstructorWeeklySchedule/InstructorWeeklySchedule"));
const CourseProgressInstructor = lazy(() => import("../Pages/Institute/CourseProgress for(Instructor)/CourseProgress_Instructor"));
const EnrolledCourseLearnerInformation = lazy(() => import("../Pages/EnrolledCourseLearnerInformation/EnrolledCourseLearnerInformation"));
const TeacherAboutStudent = lazy(() => import("../Pages/Institute/AboutStudent (For Teacher)/TeacgerAboutStudent"));
const CourseModule = lazy(() => import("../Pages/Institute/CourseModule (For Teacher)/CourseModule"));
const EnrolledCourseIns = lazy(() =>import("../Pages/Institute/EnrolledCourse By Student (For Institute)/EnrolledCourseIns"));
const AboutClient = lazy(() => import("../Pages/Institute/CourseProgress (Institute)/AboutClient"));
const Conversation = lazy(() => import("../Pages/Conversation/Conversation"));

const InstructorRoutes = () => (
  <React.Fragment>
    <Route path="/instructor/schedule" element={<InstructorSchedule />} />
    <Route path="/instructor/learner" element={<InstructorLearners />} />
    <Route path="/instructor/settings" element={<InstructorSettings />} />
    <Route path="/userleavehistory" element={<UserLeaveHistory />} />
    <Route path="/lessons" element={<InstructorLessonsDisplay />} />
    <Route path="/in-vehicle-class/:eventId" element={<InVehicleClass />} />
    <Route path="/instructor/learnerdetails/:EnrollmentId" element={<InstructorSideLearnerDetails />} />
    <Route path="/institute/batchdetails/:InstituteInClassAndBatchTimingId" element={<InClassBatchDetails />} />
    <Route path="/instructor/weeklyschedule/:InstructorId" element={<InstructorWeeklySchedule />} />
    <Route path="/teacher/CourseProgress/:EnrollmentId" element={<CourseProgressInstructor />} />
    <Route path="/enrolledcourse/learnerinfo" element={<EnrolledCourseLearnerInformation />} />
    <Route path="/teacher/AboutStudent/:EnrollmentId" element={<TeacherAboutStudent />} />
    <Route path="/teacher/CourseModule/:EnrollmentId" element={<CourseModule />} />
    <Route path="/enrolledcourse/:EnrollmentId" element={<EnrolledCourseIns />} />
    <Route path="/enrolledcourse/AboutClient/:EnrollmentId" element={<AboutClient />} />
    <Route path="/inbox" element={<Conversation />} />
  </React.Fragment>
);

// const InstructorRoutes = () => {

//   return (
//   <Routes>
//     <Route path="/instructor/schedule" element={<InstructorSchedule />} />
//     <Route path="/instructor/learner" element={<InstructorLearners />} />
//     <Route path="/instructor/settings" element={<InstructorSettings />} />
//     <Route path="/userleavehistory" element={<UserLeaveHistory />}/>
//     <Route path="/lessons" element={<InstructorLessonsDisplay />} />
//     <Route path="/in-vehicle-class/:eventId" element={<InVehicleClass />}/>
//     <Route path="/instructor/learnerdetails/:EnrollmentId" element={<InstructorSideLearnerDetails />}/>
//     <Route path="/institute/batchdetails/:InstituteInClassAndBatchTimingId" element={<InClassBatchDetails />} />
//     <Route path="/instructor/weeklyschedule/:InstructorId" element={<InstructorWeeklySchedule />}/>

//     <Route path="/teacher/CourseProgress/:EnrollmentId" element={<CourseProgressInstructor />}/> 
//     <Route path="/enrolledcourse/learnerinfo" element={<EnrolledCourseLearnerInformation />}/>
//     <Route path="/teacher/AboutStudent/:EnrollmentId" element={<TeacherAboutStudent />}/>
//     <Route path="/teacher/CourseModule/:EnrollmentId" element={<CourseModule />}/>
//     <Route path="/enrolledcourse/:EnrollmentId" element={<EnrolledCourseIns />}/>
//     <Route path="/enrolledcourse/AboutClient/:EnrollmentId" element={<AboutClient />}/>

//     <Route path="/inbox" element={<Conversation />} />    
    
//   </Routes>
//   )
// };

export default InstructorRoutes;

